import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
} from '@mui/material';

const UserForm = ({ open, onClose, onSubmit, user }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    role_id: '',
  });

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || '',
        email: user.email || '',
        password: '',
        role_id: user.role_id || '',
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    onSubmit(formData);
    onClose();
    setFormData({ name: '', email: '', password: '', role_id: '' });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{user ? 'Editează utilizator' : 'Adaugă utilizator'}</DialogTitle>
      <DialogContent>
        <TextField
          label="Nume"
          name="name"
          required
          fullWidth
          margin="normal"
          value={formData.name}
          onChange={handleChange}
        />
        <TextField
          label="E-mail"
          name="email"
          type="email"
          required
          fullWidth
          margin="normal"
          value={formData.email}
          onChange={handleChange}
        />
        {!user && (
          <TextField
            label="Password"
            name="password"
            type="password"
            required
            fullWidth
            margin="normal"
            value={formData.password}
            onChange={handleChange}
          />
        )}
        <TextField
          label="Rol"
          name="role_id"
          select
          required
          fullWidth
          margin="normal"
          value={formData.role_id}
          onChange={handleChange}
        >
          <MenuItem value={1}>Admin</MenuItem>
          <MenuItem value={2}>Educator</MenuItem>
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Anulează</Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          {user ? 'Editează' : 'Adaugă'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserForm;
